import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./accordion";

const faqData = [
  {
    q: "How do you ensure the security of our client data?",
    a: "We implement industry-standard encryption protocols and maintain strict data isolation between tenants. Your documents and information are never used to train our global models, ensuring complete confidentiality and data protection.",
  },
  {
    q: "What integrations are available for document management?",
    a: "We offer native Google Drive integration for seamless document synchronization. Additionally, Dropbox and Microsoft SharePoint integrations are available upon request to accommodate your firm's existing workflow.",
  },
  {
    q: "How reliable are the AI-generated summaries and analyses?",
    a: "Our models are specifically fine-tuned for legal document analysis. Every summary includes precise citations that link directly to the source material, enabling you to verify and validate all generated content with confidence.",
  },
  {
    q: "Do you provide enterprise pricing for larger organizations?",
    a: "Yes, we offer customized pricing packages for firms with 10 or more users. Please contact our sales team to discuss volume discounts and enterprise-specific features tailored to your organization's needs.",
  },
  {
    q: "Where is our data stored and processed?",
    a: "All data is stored and processed exclusively within EU data centers to ensure compliance with data sovereignty requirements. We can provide specific regional hosting options to meet your jurisdiction's data residency regulations.",
  },
  {
    q: "What service level agreements do you offer?",
    a: "Enterprise plans include a 99.9% uptime SLA with 24/7 priority support and dedicated account management. We provide guaranteed response times, proactive monitoring, and regular status updates to ensure business continuity.",
  },
  {
    q: "What are your data retention and deletion policies?",
    a: "You maintain full control over your data retention policies. We comply with your specified retention requirements and provide secure, certified data deletion upon request or contract termination, ensuring complete data lifecycle management.",
  },
];

export default function FAQs() {
  return (
    <section
      id="faq"
      className="scroll-py-16 py-16 md:scroll-py-32 md:py-32 bg-slate-50"
    >
      <div className="mx-auto max-w-5xl px-6">
        <div className="grid gap-y-12 px-2 lg:[grid-template-columns:1fr_auto] lg:gap-x-20">
          <div className="text-center lg:text-left">
            <h2 className="mb-4 text-3xl font-semibold md:text-4xl text-slate-900">
              Frequently <br className="hidden lg:block" /> Asked{" "}
              <br className="hidden lg:block" />
              Questions
            </h2>
            <p className="text-slate-600">
              Everything you need to know about the product and billing.
            </p>
          </div>

          <Accordion
            type="single"
            collapsible
            className="w-full sm:mx-auto sm:max-w-lg lg:mx-0 lg:w-[500px]"
          >
            {faqData.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
